import * as React from "react";
import { UserStore } from "../Dashboard/Stroes/Variable";
import { PortfolioDashboardAction } from "../Dashboard/Components/Clients/PortfolioDashboard/Action/PortfolioDashboardAction";

interface ILogoHeaderProps {}

interface ILogoHeaderState {}

export class LogoHeader extends React.Component<ILogoHeaderProps, ILogoHeaderState> {
    constructor(props: any) {
        super(props);
    }

    private clearAccountSettingsAndLogout() {
        PortfolioDashboardAction.deleteSettings((callBack) => {
            window.location.assign(`/home.aspx?logout=1`);
        });
    }

    public render(): JSX.Element {
        return (
            <header>
                <div className="container secured-header-inner">
                    <a className="app-logo">
                        <span className="sr-only">Abrdn Advisor platform</span>
                    </a>
                    <div className="layout-secured-search-wrap"></div>
                    <div className="layout-secured-custom-navigation-wrap">
                        <div className="custom-navigation">
                            <button className="btn secondary" onClick={() => this.clearAccountSettingsAndLogout()}>
                                <span className="cnt-icon" aria-hidden={true} />
                                <span className="sr-only">Logout</span>
                                <span className="cnt-label">Logout</span>
                            </button>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}
